export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14153.a7fbbb44.jpg";